import { ReactComponent as UnavailableSeatIcon } from '@eti/assets/icons/seating-buttons/default/seatButton-unavailable.svg';
import { css } from '@eti/styles';
import { Button } from '@etg/wings';
import { seatButtonStyles } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const unavailableSpanStyles = css`
  cursor: not-allowed;
  pointer-events: none;
`;
const UnavailableSeat = () => /*#__PURE__*/_jsx(Button, {
  className: `${seatButtonStyles} ${unavailableSpanStyles}`,
  children: /*#__PURE__*/_jsx(UnavailableSeatIcon, {})
});
export default UnavailableSeat;
//# sourceMappingURL=UnavailableSeat.js.map